import React from 'react';
import { useIntl } from 'react-intl';

import { IconSearch } from '@xingternal/icons';

import { useJobRoleAutocompletion } from './useJobRoleAutoComplete';

import { StyledAutoComplete } from '../JobsSearch.style';

const JobRoleAutoComplete = ({ onValueChange, value }) => {
  const { formatMessage } = useIntl();
  const {
    fetchJobRoleSuggestions,
    jobRoleSuggestions,
  } = useJobRoleAutocompletion();

  const onChange = query => {
    fetchJobRoleSuggestions(query);

    if (query !== value) {
      onValueChange(query);
    }
  };

  const onSelect = query => {
    onValueChange(query);
  };

  return (
    <StyledAutoComplete
      id="job-role-auto-complete"
      placeholder={formatMessage({
        id: 'WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER',
        defaultMessage: 'Enter a job title or keyword',
      })}
      variant="inputBar"
      suggestions={jobRoleSuggestions}
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      icon={IconSearch}
      size="large"
    />
  );
};

export default JobRoleAutoComplete;
